<template>
  <div class="doctorInfo">
    <!-- 顶部医师信息 -->
    <div class="doctor-header">
      <div class="doctor-header-left">
        <img :src="doc_info.phead" alt class="doctor-avatar" />
        <div class="doctor-meta">
          <p class="doctor-name">{{ doc_info.pname }}</p>
          <p class="doctor-desc">{{ doc_info.pinfo }}</p>
        </div>
      </div>
      <div class="doctor-header-right">
        <div class="close-btn" @click="updateMessage">×</div>
      </div>
    </div>

    <!-- 添加视频按钮 -->
    <div class="add-video-btn" @click="add_videeo">
      <span class="add-icon">＋</span>
    </div>

    <!-- 视频列表 -->
    <div class="video-list" v-if="hasVideo">
      <div class="video-card" v-for="(item,i) in v_list" :key="i" v-show="item.vcurl && !isShow_add">
        <!-- 视频封面 + 信息 -->
        <div class="video-card-top">
          <div class="video-cover">
            <video width="120" height="68" controls :src="item.vcurl + '#t=1'">您的浏览器不支持视频播放</video>
          </div>
          <div class="video-info">
            <div class="video-name">{{ item.vname }}</div>
            <div class="video-text">{{ item.vtext }}</div>
            <div class="video-pay" :class="item.ispay == 0 ? 'free' : 'paid'">
              <template v-if="item.ispay == 0">免费观看</template>
              <template v-else>价格: <span class="price">{{ item.vprice }}</span> 元</template>
            </div>
          </div>
        </div>
        <!-- 操作区 -->
        <div class="video-actions">
          <div class="action-group">
            <span class="action-link" @click="chageUrl(item)">切换播放链接</span>
            <span class="action-link" @click="g_discount_code(item)">生成优惠码</span>
          </div>
          <div class="action-group">
            <span class="action-link" @click="is_stop_pay(item)">{{ item.ispay == 1 ? '停止收费' : '开始收费' }}</span>
            <span class="action-link danger" @click="begin_play(item)">预览</span>
            <span class="action-link danger" @click="del_video(item)">删除</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 暂无视频 -->
    <div class="no-video" v-if="!hasVideo && !isShow_add">
      <p class="no-video-text">暂无视频</p>
    </div>

    <!-- 添加视频弹窗 -->
    <Popup :show="isShow_add" round class="add-v-popup">
      <div class="add-v-wrap" v-if="isShow_add">
        <div class="add-v-header">
          <span>视频上传</span>
          <div class="add-v-close" @click="close_add_popup">×</div>
        </div>
        <div class="add-v-body">
          <div class="add-v-field">
            <!-- <div class="field-label">选择视频</div>
            <Uploader
              max-count="1"
              v-model="v_list[0].vurl"
              accept="video/*"
              v-if="v_list[0].vurl == ''"
            /> -->
            <!-- <div v-else class="video-preview">
              <video width="160" height="90" controls :src="v_list[0].vurl[0].objectUrl + '#t=1'">您的浏览器不支持视频播放</video>
            </div> -->
          </div>
          <div class="ymUrl">
            <div class="field-label">源码链接</div>
            <Field  class="form-field" v-model="v_list[0].vfileurl" placeholder="请输入源码链接" maxlength="20" />
          </div>
          <div class="jmUrl">
            <div class="field-label">解码链接</div>
            <Field v-model="v_list[0].vcurl" placeholder="请输入解码链接" maxlength="20" class="form-field"/>
          </div>
          <div class="add-v-field">
            <div class="field-label">视频名称</div>
            <Field v-model="v_list[0].vname" placeholder="请输入视频名称" maxlength="20" class="form-field"/>
          </div>
          <div class="add-v-field">
            <div class="field-label">视频简介</div>
            <Field v-model="v_list[0].vtext" placeholder="请输入简介" maxlength="20" class="form-field"/>
          </div>
          <div class="add-v-field row">
            <div class="field-label">是否付费: </div>
            <Switch v-model="v_list[0].v_isPay" />
          </div>
          <div class="add-v-field" v-if="v_list[0].v_isPay">
            <div class="field-label">视频价格（元）</div>
            <Field v-model="v_list[0].v_price" placeholder="请输入价格" type="number" class="form-field"/>
          </div>
        </div>
        <div class="add-v-footer">
          <Button type="primary" size="large" block @click="update_video">上传</Button>
        </div>
      </div>
    </Popup>

    <!-- 视频播放弹窗 -->
    <Popup :show="plarurl != ''" round class="player-popup">
      <div class="player-wrap">
        <div class="player-header">
          <span>视频预览</span>
          <div class="player-close" @click="close_play_status">×</div>
        </div>
        <div class="player-body">
          <video controls ref="videoRef">
            <source :src="plarurl+'#t=1'" type="video/mp4">
            <source :src="plarurl+'#t=1'" type="video/webm">
            您的浏览器不支持 HTML5 视频标签。
          </video>
        </div>
      </div>
    </Popup>

  </div>
</template>
<script setup>
import { put_file, addVideo, getVideo, delVideo, modifyVideo, createCode } from '@/api/index'
import { computed, getCurrentInstance, onMounted, onBeforeMount, ref, nextTick } from "vue";
import { showLoadingToast, closeToast, showToast, Field, Uploader, Switch, Button, Overlay, Icon, Popup } from "vant";

import { copyText } from '@/utils/global'
import gsap from "gsap";
const props = defineProps({
  doc_info: Object,
  isShowInfo: Boolean,
});
const emit = defineEmits(["update-isShowInfo"]);
const videoRef = ref(null);
const v_list = ref([]); //视频数组
const hasVideo = computed(() => v_list.value.some(item => item.vcurl));
const add_clock = ref(false); //添加锁
const isShow_add = ref(false);
// 关闭添加视频弹窗并清空表单
const close_add_popup = () => {
  v_list.value = [];
  setTimeout(() => {
    isShow_add.value = false;
  }, 50);
};
const plarurl = ref('')
onMounted( async () => {
  showLoadingToast({
    message: "加载中...",
    duration: 0,
  });
  getdoctorInfo()
  setTimeout(() => {
    closeToast();
  }, 500);
});
// 获取医师视频信息
const getdoctorInfo = async () => {
  let res = await getVideo({pid:props.doc_info.pid})
  v_list.value = res.data
  console.log(v_list.value)
}
// 方法：触发事件，将新值传递给父组件
const updateMessage = () => {
  emit("update-isShowInfo", false);
};
// 添加视频
const add_videeo = () => {
  if (add_clock.value) {
    showToast("请勿连续点击");
    return;
  }
  add_clock.value = true;
  setTimeout(() => {
    add_clock.value = false;
  }, 1500);
  let list = v_list.value;
  gsap.to(".add-video-btn", { scale: 0.9, duration: 0.1, yoyo: 1, repeat: 1 });
  let add_list = {
    vname: "",
    vurl: [],
    vtext: "",
    v_isPay: false,
    v_price: 0,
  };
  if (v_list.value.length > 0) {
    let { vname } = v_list.value[0];
    if (vname != "") {
      list.unshift(add_list);
    }
  } else {
    list.unshift(add_list);
  }
  v_list.value = list;
  isShow_add.value = true;
};
// 上传视频
const update_video = async () =>{
  let { vname, vtext, v_isPay, v_price, vurl, vfileurl, vcurl} = v_list.value[0]
  // if(vurl.length == 0){
  //   showToast('未选择视频...')
  //   return
  // }
  if(vname == ''){
    showToast('视频名称不能为空')
    return
  }
  if(vtext == ''){
    showToast('视频简介不能为空')
    return
  }
  if(v_isPay && v_price<=0){
    showToast('价格输入不合法')
    return
  }
  showLoadingToast({
      message: '正在上传，请勿退出！！！',
      duration:0,
  })
  // let v_file = v_list.value[0].vurl[0].file
  // const formData = new FormData();
  // formData.append('files[]', v_file);
  // const response = await put_file(formData);
  // if(response.data == 501){
  //   closeToast()
  //   showToast('视频上传失败')
  //   return 
  // }
  let subData = {
    pid:props.doc_info.pid,
    vname,
    vtext,
    ispay:v_isPay ? 1 : 0,
    vprice:v_price,
    vfileurl: vfileurl,
    vcurl: vcurl,
  }
  const add_res = await addVideo(subData) 
  isShow_add.value = false
  setTimeout(()=>{
    v_list.value = []
    getdoctorInfo()
  },200)
  closeToast()
}
// 修改计费
const is_stop_pay = async (item) => {
  if(item.ispay == 1){
    const isConfirmed = confirm("确定要停止计费吗？");
    if(isConfirmed){
      // 停止计费
      await modifyVideo({ispay:0,vprice:0,vid:item.vid})
      getdoctorInfo()
    }
  }else{
    const videoPrice = prompt("请输入视频价格(以元为单位)");
    if (videoPrice && videoPrice > 0) {
      // 停止计费
      await modifyVideo({ispay:1,vprice:videoPrice,vid:item.vid})
      getdoctorInfo()
    }
  }
}
// 切换播放链接
const chageUrl = async (e) =>{
  // 0: 编码视频 1:源码视频
  let text = '当前播放链接为编码后的视频链接,是否切换为源码链接'
  if( e.isoriginal == 1 ){
    text =  '当前播放链接为源码链接,是否切换为编码后的视频链接'
  }
  let val = e.isoriginal;
  const isConfirmed = confirm(text); 
  if( isConfirmed ){
    val = val == 0 ? 1 : 0
    await modifyVideo({isoriginal:val,vid:e.vid})
    getdoctorInfo()
  }
}
// 删除视频
const del_video = async(e) => {
  const isConfirmed = confirm('确认删除该视频吗，删除后将无法恢复！'); 
  if( isConfirmed ){
    await delVideo({vid:e.vid})
    getdoctorInfo()
  }
}
// 关闭预览
const close_play_status = () => {
  if (videoRef.value) {
    videoRef.value.pause(); // 先暂停视频
    videoRef.value.src = "";
    plarurl.value = ""; // 清空响应式数据
  }
}
// 开启预览
const begin_play = (item) => {
  plarurl.value = item.isoriginal == 0 ? item.vcurl : item.vfileurl;
  nextTick(() => {
    if (plarurl.value) {
      videoRef.value.src = plarurl.value
      videoRef.value.load(); // 重新加载视频
      videoRef.value.play().catch(error => {
        console.error("播放失败:", error);
      });
    }
  });
}
// 生成优惠码
const g_discount_code =async (e) =>{
  if(e.ispay == 0){
    showToast('该视频为免费视频')
    return
  }
  
  showLoadingToast({
    message: "生成中...",
    duration: 0,
  });
  let res = await createCode({vid:e.vid,vname:e.vname})
  setTimeout(()=>{
    closeToast()
    let { vname, dcode } = res.data
    if(res.data.dcode){
      copyText(vname,dcode)
    }
    else{
      showToast('生成失败,请重试')
    }
  },1500)
}
</script>
<style lang="less">
.form-field.van-field {
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 12px 14px;
  font-size: 14px;
  background: #fafafa;
  transition: all 0.2s;
}
// ===== 主容器 =====
.doctorInfo {
  height: 100%;
  overflow-y: auto;
  background: #f0f2f5;
  padding: 20px;
}

// ===== 顶部医师信息 =====
.doctor-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
  margin-bottom: 20px;
}
.doctor-header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}
.doctor-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #e8e8e8;
}
.doctor-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.doctor-name {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
}
.doctor-desc {
  font-size: 13px;
  color: #888;
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.doctor-header-right {
  flex-shrink: 0;
}
.close-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #999;
  cursor: pointer;
  transition: all 0.2s;
  line-height: 1;
  font-weight: bold;
  &:hover {
    background: #ff4d4f;
    color: #fff;
  }
}
// ===== 暂无视频 =====
	.no-video {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 60px 0;
		.no-video-text {
			font-size: 14px;
			color: #999;
		}
	}
	// ===== 添加视频按钮 =====
.add-video-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 50px;
  border-radius: 50%;
  height: 50px;
  background: linear-gradient(135deg, #4f46e5, #7c3aed);
  color: #fff;
  font-size: 30px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(79,70,229,0.3);
  background: linear-gradient(135deg, #4f46e5, #6366f1, #818cf8);
  position: absolute;
  bottom: 30px;
  right: 40px;
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(79,70,229,0.4);
  }
  &:active {
    transform: translateY(0);
  }
}
.add-icon {
  margin-top: -5px;
  font-size: 38px;
  font-weight: bold;
}

// ===== 视频列表 =====
.video-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 20px;
}
.video-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
  transition: box-shadow 0.2s;
  &:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }
}
.video-card-top {
  display: flex;
  gap: 16px;
  margin-bottom: 12px;
}
.video-cover {
  flex-shrink: 0;
  border-radius: 8px;
  overflow: hidden;
  background: #000;
  video {
    display: block;
    border-radius: 8px;
  }
}
.video-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}
.video-name {
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.video-text {
  font-size: 13px;
  color: #888;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.video-pay {
  font-size: 13px;
  &.free {
    color: #00b578;
  }
  &.paid {
    color: #ff8f1a;
  }
  .price {
    font-weight: 600;
    font-size: 15px;
  }
}

// ===== 操作区 =====
.video-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #f0f0f0;
  padding-top: 12px;
}
.action-group {
  display: flex;
  gap: 16px;
}
.action-link {
  font-size: 13px;
  color: #4f46e5;
  cursor: pointer;
  transition: color 0.2s;
  line-height: 1.6;
  &.danger {
    color: #ff4d4f;
    &:hover {
      color: #d9363e;
    }
  }
  &:hover {
    color: #7c3aed;
  }
}

// ===== 添加视频弹窗 =====
.add-v-popup {
  width: 90%;
  max-width: 460px;
  max-height: 85vh;
  border-radius: 16px !important;
}
.add-v-wrap {
  display: flex;
  flex-direction: column;
  max-height: 85vh;
}
.add-v-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px 20px;
  font-size: 17px;
  font-weight: 600;
  color: #1a1a1a;
  border-bottom: 1px solid #ebedf0;
  position: relative;
  flex-shrink: 0;
}
.add-v-close {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #999;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: bold;
  line-height: 1;
  &:hover {
    background: #ff4d4f;
    color: #fff;
  }
}
.add-v-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.add-v-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
&.row {
  flex-direction: row;
  align-items: center;
  // justify-content: space-between;
  .van-switch {
    transform: scale(0.75);
    transform-origin: right center;
    margin-right: -8px;
  }
  .van-switch__node {
    box-shadow: 0 2px 6px rgba(0,0,0,0.25);
  }
}
}
.field-label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}
.video-preview {
  border-radius: 8px;
  overflow: hidden;
  background: #000;
  width: fit-content;
  video {
    display: block;
  }
}
.add-v-footer {
  padding: 16px 20px;
  border-top: 1px solid #ebedf0;
  flex-shrink: 0;
}

// ===== 视频播放弹窗 =====
.player-popup {
  width: 90%;
  max-width: 720px;
  border-radius: 16px !important;
  overflow: hidden;
}
.player-wrap {
  display: flex;
  flex-direction: column;
}
.player-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 20px;
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  border-bottom: 1px solid #ebedf0;
  position: relative;
  flex-shrink: 0;
}
.player-close {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #999;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: bold;
  line-height: 1;
  &:hover {
    background: #ff4d4f;
    color: #fff;
  }
}
.player-body {
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  video {
    width: 100%;
    max-height: 60vh;
    border-radius: 8px;
  }
}
</style>
